export const FETCHING_DATA = 'src/components/Patient/Percentil/FETCHING_DATA'
export const FETCHING_DATA_SUCCESS = 'src/components/Patient/Percentil/FETCHING_DATA_SUCCESS'
export const FETCHING_DATA_ERROR = 'src/components/Patient/Percentil/FETCHING_DATA_ERROR'

export const SET_CALC_AFECTO = 'src/components/Patient/Percentil/CALC_AFECTO'



// WEBPACK FOOTER //
// ./src/redux/actionTypes/percentil.js